// .c-others-estate-list-header のスクロール連動表示制御
// 下スクロール: data-hidden を付与して非表示（ヘッダー／エリアバーの下へ潜り込ませる）
// 上スクロール: data-hidden を除去して再表示
// resources/js/pages/estate/detail.js の setNavScroll と同じロジック
const main = () => {
    const el = document.querySelector(".c-others-estate-list-header");
    if (!el) return;

    let lastY = window.scrollY;

    const onScroll = () => {
        const currentY = window.scrollY;
        const isAtTop = currentY === 0;
        // 自身の高さぶんもスクロールしていない段階では隠さない（読み込み直後のちらつき防止）
        const isScrollingDown = currentY > lastY && currentY > el.offsetHeight;

        el.toggleAttribute("data-hidden", !isAtTop && isScrollingDown);
        lastY = currentY;
    };

    window.addEventListener("scroll", onScroll, { passive: true });
};

export default main;
